import { PropsWithChildren } from 'react'
import { Callback } from 'types/index'
import { FlexBox } from 'ui/primitives'
import { option } from './Option.css'

interface Props {
	selected?: boolean
	disabled?: boolean
	onClick: Callback<never>
}

export const OptionComponent = ({ children, selected, disabled, onClick }: PropsWithChildren<Props>) => {
	return (
		<FlexBox
			component="button"
			className={option}
			padding="none"
			aria-disabled={disabled}
			alignItems="center"
			aria-selected={selected}
			backgroundColor="common.white"
			justifyContent="center"
			borderRadius="none"
			direction="column"
			onClick={onClick}
		>
			{children}
		</FlexBox>
	)
}
